import React from "react"
import "./index.scss"
import {BootstrapTooltip} from "../../Tooltip"
import {exportToCSV} from "../../../utils/utils"
import Download from "../../../assets/svg/download.svg"

export default function ChartContainer(props) {
  const {type, label, csvData, hideDownload, showMinMax, max, min} = props
  const downloadIcon = !hideDownload && (
    <BootstrapTooltip title="Download Data" placement="top">
      <img
        className="download"
        src={Download}
        alt="download"
        onClick={(e) => exportToCSV(csvData, label)}
      />
    </BootstrapTooltip>
  )
  const minMax = showMinMax && (
    <label className="min-max">
      <p>
        Max {max}&nbsp;-&nbsp;Min {min}
      </p>
    </label>
  )

  return (
    <div className={`chart-container ${type}`}>
      <div className="chart-header">
        {downloadIcon}
        <label className="chart-label">{label}</label>
        {minMax}
      </div>
      {props.children}
    </div>
  )
}
